import heroGraphic from '@/assets/login-hero-illustration-cropped.webp';
import styles from './HeroNetworkIllustration.module.css';

export function HeroNetworkIllustration() {
  return (
    <div className={styles.wrapper}>
      <img
        src={heroGraphic}
        alt="Intelligent workflow platform 3D dashboard illustration"
        className={styles.graphicImage}
        width={669}
        height={794}
        loading="eager"
        decoding="async"
        // This is the largest thing on the login screen and the only image
        // above the fold, so it is told to compete with the scripts rather
        // than wait behind them.
        fetchPriority="high"
      />
    </div>
  );
}
